export enum Endpoints {
    GET = '/settings',
}
